<script>
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import { required, numeric } from '@vuelidate/validators';
import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: {
    PageHeader,
    NextButton,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      inboxName: '',
      sipServer: '',
      wssPort: 8089,
      extension: '',
      password: '',
      context: 'from-internal',
      callerId: '',
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
    }),
  },
  validations: {
    inboxName: { required },
    sipServer: { required },
    wssPort: { required, numeric },
    extension: { required },
    password: { required },
  },
  methods: {
    async createChannel() {
      this.v$.$touch();
      if (this.v$.$invalid) return;

      try {
        const sipChannel = await this.$store.dispatch('inboxes/createChannel', {
          name: this.inboxName?.trim(),
          channel: {
            type: 'sip',
            sip_server: this.sipServer,
            wss_port: parseInt(this.wssPort),
            extension: this.extension,
            password: this.password,
            context: this.context,
            caller_id: this.callerId,
          },
        });

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: { page: 'new', inbox_id: sipChannel.id },
        });
      } catch (error) {
        useAlert(error.message || 'Erro ao criar caixa de entrada SIP');
      }
    },
  },
};
</script>

<template>
  <div class="h-full w-full p-6 col-span-6">
    <PageHeader
      header-title="SIP / VoIP"
      header-content="Configure uma caixa de entrada SIP para receber e fazer chamadas VoIP via WebRTC conectando ao seu PBX (Issabel/Asterisk)."
    />
    <form
      class="flex flex-wrap flex-col mx-0 max-w-xl"
      @submit.prevent="createChannel()"
    >
      <div class="flex-shrink-0 flex-grow-0">
        <label :class="{ error: v$.inboxName.$error }">
          Nome da Caixa de Entrada
          <input
            v-model="inboxName"
            type="text"
            placeholder="Ex: Telefonia, Ramal 410"
            @blur="v$.inboxName.$touch"
          />
          <span v-if="v$.inboxName.$error" class="message">Obrigatorio</span>
        </label>
      </div>

      <div class="flex-shrink-0 flex-grow-0">
        <label :class="{ error: v$.sipServer.$error }">
          Servidor SIP
          <input
            v-model="sipServer"
            type="text"
            placeholder="Ex: telefonia.empresa.com.br"
            @blur="v$.sipServer.$touch"
          />
          <span v-if="v$.sipServer.$error" class="message">Obrigatorio</span>
        </label>
      </div>

      <div class="flex gap-4">
        <div class="flex-1">
          <label :class="{ error: v$.extension.$error }">
            Ramal (Extension)
            <input
              v-model="extension"
              type="text"
              placeholder="Ex: 410"
              @blur="v$.extension.$touch"
            />
            <span v-if="v$.extension.$error" class="message">Obrigatorio</span>
          </label>
        </div>
        <div class="flex-1">
          <label :class="{ error: v$.wssPort.$error }">
            Porta WSS
            <input
              v-model.number="wssPort"
              type="number"
              placeholder="8089"
              @blur="v$.wssPort.$touch"
            />
          </label>
        </div>
      </div>

      <div class="flex-shrink-0 flex-grow-0">
        <label :class="{ error: v$.password.$error }">
          Senha SIP
          <input
            v-model="password"
            type="password"
            placeholder="Senha do ramal"
            @blur="v$.password.$touch"
          />
          <span v-if="v$.password.$error" class="message">Obrigatorio</span>
        </label>
      </div>

      <div class="flex gap-4">
        <div class="flex-1">
          <label>
            Contexto
            <input
              v-model="context"
              type="text"
              placeholder="from-internal"
            />
          </label>
        </div>
        <div class="flex-1">
          <label>
            Caller ID
            <input
              v-model="callerId"
              type="text"
              placeholder="Ex: Atendimento <410>"
            />
          </label>
        </div>
      </div>

      <div class="w-full mt-4">
        <NextButton
          :is-loading="uiFlags.isCreating"
          type="submit"
          solid
          blue
          label="Criar Caixa de Entrada SIP"
        />
      </div>
    </form>
  </div>
</template>
